import './correspondences_types';
import './correspondences_types-list';
import './correspondences_types-edit'; 